/*
 * @创建人: zll
 * @修改人:zll
 * @描述: 获取系统id
 * @创建时间: 2020-06-10 16:43:10
 * @修改时间: 2020-06-10 16:43:10
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SwHttpClientService } from '../sw-http-client.service';
import { environment } from 'src/environments/environment';

/**
 * 获取系统id 
 */
@Injectable()
export class GlobalSearchService {

  /**
   * @ignore
   */
  constructor(
    private http:SwHttpClientService,  //封装的http请求服务
  ) { }

    /**
   * 全局搜索服务
   * @param param 请求参数
   *
   */
  globalSearch(param){
    const url = environment.esWebAPI + 'globalSearch';
    return this.http.Post(url, param);
  }
}
